

import PhotoSwipe from '../modules/PhotoSwipe';

import {initPhotoswipeSmartBullets} from './SmartBullets';

const initPhotoSwipe = function() {

	const photoSwipeElement = document.querySelector( '.pswp' );
	if ( photoSwipeElement ) {

		// Initialise Photoswipe Lightbox Gallery.
		PhotoSwipe.init( {
			classNames: {
				bullet: 'pswp__bullet',
				active: 'is-active'
			},
		} );

		// Handle Observer Logic for Smart Bullets.
		let observers = [];
		PhotoSwipe.on( 'open', () => {
			observers.forEach( function( observer ) {
				observer.disconnect();
			} );
			observers = initPhotoswipeSmartBullets()
		} );
		PhotoSwipe.on( 'close', () => {
			observers.forEach( function( observer ) {
				observer.disconnect();
			} );
			observers = [];
		} );
	}

	// Preload images in PhotoSwipe Gallery after a few seconds
	setTimeout( () => {
		PhotoSwipe.preloadImages( 1 );
	}, 2000 );

}

export {
	PhotoSwipe as default,
	initPhotoSwipe,
}